import { faker } from '@faker-js/faker'

import { mockLabels, attachments } from '~/shared/mocking'
import { COMMENT_STATUS } from '~/modules/post/constants'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'service' implicitly has an 'any' type.
const getAttachment = (service) => {
  const attachment = faker.helpers.arrayElement(attachments)
  return service === 'facebook' && Math.random() < 0.5 ? attachment : null
}

/**
 *
 */
export default function mockComment({
  // @ts-expect-error TS(2525) FIXME: Initializer provides no value for this binding ele... Remove this comment to see the full error message
  replies,
  service = 'instagram',
  override = {},
} = {}) {
  const buildComment = () => ({
    id: faker.string.uuid(),
    text: faker.lorem.paragraph(),
    createdAt: faker.date.past({ years: 2 }),
    from: {
      username: `buffer${faker.number.int()}`,
      isChannel: false,
    },
    replies: [],
    needsAttention: faker.datatype.boolean(),
    error: null,
    labels: mockLabels(),
    status: COMMENT_STATUS.PENDING,
    attachment: getAttachment(service),
  })

  const comment = buildComment()

  if (service === 'facebook' && comment.attachment) {
    // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
    comment.text = Math.random() < 0.9 ? null : comment.text
  }

  const repliesCount =
    replies !== undefined ? replies : faker.number.int({ min: -1, max: 10 })

  for (let r = 0; r < repliesCount; r++) {
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; text: string; crea... Remove this comment to see the full error message
    comment.replies.push(buildComment())
  }

  return {
    ...comment,
    ...override,
  }
}
